import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { LabsService, type LabPrice, type LabPriceCreate, type LabPriceUpdate } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";
import { fetchAll } from "./fetchAll";

export const useLabPrices = () =>
  useQuery({
    queryKey: ["lab-prices"],
    queryFn: () => fetchAll<LabPrice>(LabsService.getApiLabPrices),
    staleTime: 5 * 60_000,
  });

export const useCreateLabPrice = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: LabPriceCreate) => {
      const res = await LabsService.postApiLabPrices({ body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as LabPrice;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["lab-prices"] }),
  });
};

export const useUpdateLabPrice = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: LabPriceUpdate }) => {
      const res = await LabsService.putApiLabPricesById({ path: { id }, body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as LabPrice;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["lab-prices"] }),
  });
};

export const useDeleteLabPrice = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await LabsService.deleteApiLabPricesById({ path: { id }, headers: getAuthHeaders() });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["lab-prices"] }),
  });
};
